package ui.demoMerchantAdmin

import ConfigFile
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import androidx.lifecycle.ViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.StateFlow
import model.DataRepository
import model.DeleteCard
import model.MerchantFullInformationV3
import model.NavigationRepository
import model.NavigationRepository.DialogState
import org.koin.compose.koinInject
import ui.DisposableViewModel
import ui.ScopeHolderFactory

@Composable
fun demoMerchantViewModel(
    scopeHolderFactory: ScopeHolderFactory = koinInject(),
): DemoMerchantViewModel {
    val scopeHolder = remember { scopeHolderFactory.getOrCreate(DemoMerchantViewModel::class) }
    DisposableEffect(Unit) { onDispose { scopeHolder.detach() } }
    return remember { scopeHolder.attach() }
}

class DemoMerchantViewModel(
    val clientConfig: ConfigFile,
    private val dataRepository: DataRepository,
    private val navigationRepository: NavigationRepository,
) : ViewModel(), DisposableViewModel {

    private val job = SupervisorJob()
    private val viewmodelScope = CoroutineScope(job + Dispatchers.Main)

    val cardDeleteStateFlow: StateFlow<DataRepository.CardState> = dataRepository.cardDeleteStateFlow
    val merchantInformationStateFlow: StateFlow<MerchantFullInformationV3?> = dataRepository.merchantInformationStateFlow
    val dialogStateMutableStateFlow = navigationRepository.dialogStateMutableStateFlow


    init {
        println("DemoMerchantViewModel has been created!")
    }

    fun loadDeleteCardAsync() {
        dataRepository.loadDeleteCardAsync(
            cardDeleteStateFlow.value.cards,
            merchantInformationStateFlow.value!!.consumerLoyaltyProgramGuid!!
        )
    }

    fun deleteCard(deleteCard: DeleteCard) {
        dialogStateMutableStateFlow.value = DialogState.DeleteCard() {
            dialogStateMutableStateFlow.value = DialogState.Nothing()
            if (it) {
                dataRepository.deleteCard(deleteCard)
            }
        }
    }

    override fun dispose() {
        println("DemoMerchantViewModel.dispose()")
        job.cancel()
    }
}